import moment from 'moment';

export function round(amount) {
  if (!amount) {
    return 0;
  }

  if (typeof amount === 'string') {
    amount = amount.replace(',', '.');
    amount = Number.parseFloat(amount);
  }

  if (amount >= 10) {
    return amount.toLocaleString('nl-NL', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  let decimals = 2;

  if (amount > 1) {
    decimals = 1;
  }

  return amount.toLocaleString('nl-NL', {
    style: 'decimal',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  // return amount.toLocaleString('nl-NL', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function roundCurrency(amount) {
  if (!amount) {
    amount = 0;
  }

  if (typeof amount === 'string') {
    amount = amount.replace(',', '.');
    amount = Number.parseFloat(amount);
  }

  if (amount < 10) {
    return amount.toLocaleString('nl-NL', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  return amount.toLocaleString('nl-NL', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

export function mapYields({ labels, yield: yields }) {
  return labels
    .map((label, index) => {
      const date = moment(label, 'YYYY-MM-DD');

      return {
        year: date.year(),
        month: date.month(),
        day: date.date(),
        label: date.format('MMMM'),
        yield: yields[index],
      };
    })
    .reverse();
}

export function getMonths() {
  return moment.monthsShort();
}
